import classNames from 'classnames'
import { forwardRef, HTMLAttributes } from 'react'

import { Slot } from '../utilities'
import styles from './snippet-tail.module.scss'

export type SnippetTailElement = HTMLDivElement

export type SnippetTailProps = HTMLAttributes<SnippetTailElement> & {
  asChild?: boolean
}

const SnippetTail = forwardRef<SnippetTailElement, SnippetTailProps>(function SnippetTail(
  props,
  forwardedRef
) {
  const { children, className, asChild, ...rest } = props

  const classes = classNames(styles.root, className)

  const Component = asChild ? Slot : 'div'

  return (
    <Component {...rest} className={classes} ref={forwardedRef}>
      {children}
    </Component>
  )
})

export default SnippetTail
